import { useNavigate } from "react-router-dom";
import HeaderTitle from "src/commonStyles/text/headerTitle/headerTitle";
import QueryContract from "src/components/homePage/components/queryContract/queryContract";
import StepsPayment from "src/components/homePage/components/steps/steps";
import PATH from "src/routes/route-path";
const Home = () => {
  const navigate = useNavigate();
  const onNextStep = () => {
    navigate(PATH.INFOPAY);
  };
  const onPressStep = (step: any) => {};
  localStorage.removeItem("paymentResult");
  localStorage.clear();

  return (
    <div>
      <HeaderTitle>Đóng phí bảo hiểm</HeaderTitle>
      <StepsPayment step={0} onPressStep={onPressStep} />
      <div>
        <QueryContract onNextStep={onNextStep} />
      </div>
    </div>
  );
};

export default Home;
